import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea", "submitButton", "aiOutput"];

  static values = {
    rows: Number,
  };
  connect() {
    this.autoResizeTextArea();
    this.observeIaOutput();
  }

  autoResizeTextArea() {
    const el = this.textareaTarget;
    // Reset height
    el.style.height = "auto";
    const lines = el.value.split("\n");
    const rows = lines.length;
    if (rows < this.rowsValue || rows > 10) return;
    el.setAttribute("rows", Math.ceil(rows));
  }

  validate(event) {
    this.autoResizeTextArea();
    const isEmpty = this.textareaTarget.value.trim() === "";
    this.toggleSubmitButton(isEmpty);

    if (isEmpty) {
      event.preventDefault();
      return;
    }

  }

  submit() {
    this.submitButtonTarget.form.requestSubmit();
  }

  toggleSubmitButton(condition) {
    if (condition) {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add(
        "bg-gray-500",
        "cursor-not-allowed",
        "hover:bg-gray-500"
      );
    } else {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove(
        "bg-gray-500",
        "cursor-not-allowed",
        "hover:bg-gray-500"
      );
    }
  }

  observeIaOutput() {
    // Observer le contenu du node Turbo Stream
    const observer = new MutationObserver(() => {
      this.textareaTarget.value = this.aiOutputTarget.innerText;
      this.textareaTarget.dispatchEvent(new Event("input"));
    });

    observer.observe(this.aiOutputTarget, { childList: true });
  }
}
